module.exports = __webpack_public_path__ + "images/psp/CarStorage/car-related1.jpg";